import { isRequiredForPeriod } from "@core/reports/utils/requiredStarting";

/**
 * Whether a KPI is required for the given report tag period.
 * Thin wrapper around shared Required starting semantics.
 */
export function isKpiRequiredForReportTag(
  kpiIsRequired: boolean,
  kpiRequiredAt: string | null | undefined,
  reportTagSince: string | null | undefined,
  reportTagUntil: string | null | undefined,
  asOf: Date = new Date()
): boolean {
  return isRequiredForPeriod(
    kpiIsRequired,
    kpiRequiredAt,
    reportTagSince,
    reportTagUntil,
    asOf
  );
}
